import { render, staticRenderFns } from "./AreasDialog.vue?vue&type=template&id=06df4fff&"
import script from "./AreasDialog.vue?vue&type=script&lang=js&"
export * from "./AreasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports